import { render, staticRenderFns } from "./ReceptionMobile.vue?vue&type=template&id=0b28114e&"
import script from "./ReceptionMobile.vue?vue&type=script&lang=js&"
export * from "./ReceptionMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage})
